const axios = require("axios").default;

const URL = `${process.env.REACT_APP_API_URL}/setting`;
const URL_BASE = `${process.env.REACT_APP_API_URL}`;

export const getAll = (payload) => {
  return axios.get(URL, {
    params: payload,
  });
};

export const getId = (id) => {
  return axios.get(`${URL}/${id}`, {
    params: id,
  });
};

export const createItem = (payload) => {
  return axios.post(URL, payload);
};

export const updateItem = (payload, id) => {
  return axios.put(`${URL}/${id}`, payload);
};

export const deleteById = (id) => {
  return axios.delete(`${URL}/${id}`);
};

export const getSynchNrax = (i_Principal, i_Customer, i_Material, i_PH3) => {
  return axios
    .post(
      `${URL_BASE}/nra/nrax/synch?i_Principal=${i_Principal}&i_Customer=${i_Customer}&i_Material=${i_Material}&i_PH3=${i_PH3}&limit=0&offset=0`
    )
    .catch((error) => {
      if (error.response) {
        return error.response.data;
      } else if (error.request) {
        console.log(error.request);
      } else {
        console.log(error.message);
      }
    });
};

export const getSynchNrablank = (
  i_Principal,
  i_Customer,
  i_Material,
  i_PH3
) => {
  return axios
    .post(
      `${URL_BASE}/nra/nrablank/synch?i_Principal=${i_Principal}&i_Customer=${i_Customer}&i_Material=${i_Material}&i_PH3=${i_PH3}&limit=0&offset=0`
    )
    .catch((error) => {
      if (error.response) {
        return error.response.data;
      } else if (error.request) {
        console.log(error.request);
      } else {
        console.log(error.message);
      }
    });
};

export const getSynchCustomer = (P_CustomerCode, P_CustomerName) => {
  return axios
    .post(
      `${URL_BASE}/customer/synch?P_CustomerCode=${P_CustomerCode}&P_CustomerName=${P_CustomerName}&limit=0&offset=0`
    )
    .catch((error) => {
      if (error.response) {
        return error.response.data;
      } else if (error.request) {
        console.log(error.request);
      } else {
        console.log(error.message);
      }
    });
};

export const getSynchNracustx = (i_Principal, i_Customer, i_CustGroup2) => {
  return axios
    .post(
      `${URL_BASE}/nra/nracustx/synch?i_Principal=${i_Principal}&i_Customer=${i_Customer}&i_CustGroup2=${i_CustGroup2}&limit=0&offset=0`
    )
    .catch((error) => {
      if (error.response) {
        return error.response.data;
      } else if (error.request) {
        console.log(error.request);
      } else {
        console.log(error.message);
      }
    });
};

export const getSynchNracustblank = (i_Principal, i_Customer, i_CustGroup2) => {
  return axios
    .post(
      `${URL_BASE}/nra/nracustblank/synch?i_Principal=${i_Principal}&i_Customer=${i_Customer}&i_CustGroup2=${i_CustGroup2}&limit=0&offset=0`
    )
    .catch((error) => {
      if (error.response) {
        return error.response.data;
      } else if (error.request) {
        console.log(error.request);
      } else {
        console.log(error.message);
      }
    });
};

export const getSynchMaterial = (P_material, P_DistChannel) => {
  return axios
    .post(
      `${URL_BASE}/material/synch?P_material=${P_material}&P_DistChannel=${P_DistChannel}&limit=0&offset=0`
    )
    .catch((error) => {
      if (error.response) {
        return error.response.data;
      } else if (error.request) {
        console.log(error.request);
      } else {
        console.log(error.message);
      }
    });
};

export const getSynchFPRE = (payload) => {
  return axios.post(`${URL_BASE}/client/fpre/synch`).catch((error) => {
    if (error.response) {
      return error.response.data;
    } else if (error.request) {
      console.log(error.request);
    } else {
      console.log(error.message);
    }
  });
};

export const getSynchMaterialExt = (
  tableName,
  P_SalesOrg,
  P_Material,
  P_Customer,
  P_Batch,
  P_Plant,
  P_IC4,
  P_DocCat,
  P_CG1
) => {
  return axios
    .post(
      `${URL_BASE}/material/synchexclusion?P_SalesOrg=${P_SalesOrg}&P_Material=${P_Material}&P_Customer=${P_Customer}&P_Batch=${P_Batch}&P_Plant=${P_Plant}&P_IC4=${P_IC4}&P_DocCat=${P_DocCat}&P_CG1=${P_CG1}&limit=0&offset=0`
    )
    .catch((error) => {
      if (error.response) {
        return error.response.data;
      } else if (error.request) {
        console.log(error.request);
      } else {
        console.log(error.message);
      }
    });
};

export const getSynchCrprgp = (payload) => {
  return axios.post(`${URL_BASE}/crprgp/synch`, payload).catch((error) => {
    if (error.response) {
      return error.response.data;
    } else if (error.request) {
      console.log(error.request);
    } else {
      console.log(error.message);
    }
  });
};

export const getSynchBatch = (P_MATERIAL, P_BATCH) => {
  return axios
    .post(
      `${URL_BASE}/batch/synch?P_MATERIAL=${P_MATERIAL}&P_BATCH=${P_BATCH}&limit=0&offset=0`
    )
    .catch((error) => {
      if (error.response) {
        return error.response.data;
      } else if (error.request) {
        console.log(error.request);
      } else {
        console.log(error.message);
      }
    });
};
